<template>
    <div class="wa-status">
        <SOSlotBase :container-name="'create-status-wa'" :loading="!formReady">
            <template v-slot:title-bar>
                <SOTitleBar :type="'back'" :page-title="getTitle" @back="back" />
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-x-20 p-t-16">
                    <form class="form-create-status">
                        <div class="form-group">
                            <SoModalOptions
                                ref="divice-wa"
                                :title="'Perangkat WA'"
                                :selectedOption="posted.iddevice"
                                :placeholder="'Pilih perangkat'"
                                :options="deviceOptions"
                                :id="'device-wa'"
                                :required="true"
                                :disabled="dataDeviceTiny.iddevice != undefined"
                                :isBtnLink="false"
                                @onSelected="onSelectedOpt($event, 'iddevice')"
                            />
                            <div class="v-error d-none" id="e-device-wa">
                                Perangkat WA tidak boleh kosong
                            </div>
                        </div>
                    </form>
                    <label class="m-d-0 require f-c-midgrey f-regular f-14">Konten</label>
                    <div class="upload-container" v-if="!isEdit">
                        <div class="upload" @click="gotoUpload" v-if="!fileUpload">
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M16 0.5C16.5523 0.5 17 0.947715 17 1.5V3.5H19C19.5523 3.5 20 3.94772 20 4.5C20 5.05228 19.5523 5.5 19 5.5H17V7.5C17 8.05228 16.5523 8.5 16 8.5C15.4477 8.5 15 8.05228 15 7.5V5.5H13C12.4477 5.5 12 5.05228 12 4.5C12 3.94772 12.4477 3.5 13 3.5H15V1.5C15 0.947715 15.4477 0.5 16 0.5ZM6.58579 2.08579C6.96086 1.71071 7.46957 1.5 8 1.5H10C10.5523 1.5 11 1.94772 11 2.5C11 3.05228 10.5523 3.5 10 3.5L8 3.5C8 4.29565 7.68393 5.05871 7.12132 5.62132C6.55871 6.18393 5.79565 6.5 5 6.5H3C2.73478 6.5 2.48043 6.60536 2.29289 6.79289C2.10536 6.98043 2 7.23478 2 7.5V16.5C2 16.7652 2.10536 17.0196 2.29289 17.2071C2.48043 17.3946 2.73478 17.5 3 17.5H17C17.2652 17.5 17.5196 17.3946 17.7071 17.2071C17.8946 17.0196 18 16.7652 18 16.5V9.5C18 8.94772 18.4477 8.5 19 8.5C19.5523 8.5 20 8.94772 20 9.5V16.5C20 17.2957 19.6839 18.0587 19.1213 18.6213C18.5587 19.1839 17.7957 19.5 17 19.5H3C2.20435 19.5 1.44129 19.1839 0.87868 18.6213C0.31607 18.0587 0 17.2957 0 16.5V7.5C0 6.70435 0.31607 5.94129 0.87868 5.37868C1.44129 4.81607 2.20435 4.5 3 4.5H5C5.26522 4.5 5.51957 4.39464 5.70711 4.20711C5.89464 4.01957 6 3.76522 6 3.5C6 2.96957 6.21071 2.46086 6.58579 2.08579ZM10 9.5C8.89543 9.5 8 10.3954 8 11.5C8 12.6046 8.89543 13.5 10 13.5C11.1046 13.5 12 12.6046 12 11.5C12 10.3954 11.1046 9.5 10 9.5ZM6 11.5C6 9.29086 7.79086 7.5 10 7.5C12.2091 7.5 14 9.29086 14 11.5C14 13.7091 12.2091 15.5 10 15.5C7.79086 15.5 6 13.7091 6 11.5Z"
                                    fill="#C8D0DD"
                                />
                            </svg>
                            <p class="m-d-0 f-14 f-regular m-t-8" style="color: #C8D0DD">Upload foto / video...</p>
                        </div>
                        <div class="uploaded" v-else>
                            <div style="background-color: black;" id="files-content" @hook:mounted="handleFiles"></div>
                            <div class="d-flex btn-cont">
                                <div class="act-btn" @click="openUpload">
                                    <label class="m-d-0 f-c-blue">{{ updateCaption }}</label>
                                </div>
                                <div class="act-btn" @click="clearFile">
                                    <label class="m-d-0 f-c-red">Hapus</label>
                                </div>
                            </div>
                        </div>
                        <div class="m-t-12">
                            <textarea
                                class="input-caption"
                                v-model="posted.caption"
                                placeholder="Tambahkan caption (opsional)..."
                                @input="handleInput"
                            ></textarea>
                        </div>
                    </div>
                    <div class="upload-container" v-if="isEdit && posted.type_media">
                        <div
                            class="upload"
                            @click="gotoUpload"
                            v-if="!fileUpload && (isText(posted.type_media) || isNomedia)"
                        >
                            <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M16 0.5C16.5523 0.5 17 0.947715 17 1.5V3.5H19C19.5523 3.5 20 3.94772 20 4.5C20 5.05228 19.5523 5.5 19 5.5H17V7.5C17 8.05228 16.5523 8.5 16 8.5C15.4477 8.5 15 8.05228 15 7.5V5.5H13C12.4477 5.5 12 5.05228 12 4.5C12 3.94772 12.4477 3.5 13 3.5H15V1.5C15 0.947715 15.4477 0.5 16 0.5ZM6.58579 2.08579C6.96086 1.71071 7.46957 1.5 8 1.5H10C10.5523 1.5 11 1.94772 11 2.5C11 3.05228 10.5523 3.5 10 3.5L8 3.5C8 4.29565 7.68393 5.05871 7.12132 5.62132C6.55871 6.18393 5.79565 6.5 5 6.5H3C2.73478 6.5 2.48043 6.60536 2.29289 6.79289C2.10536 6.98043 2 7.23478 2 7.5V16.5C2 16.7652 2.10536 17.0196 2.29289 17.2071C2.48043 17.3946 2.73478 17.5 3 17.5H17C17.2652 17.5 17.5196 17.3946 17.7071 17.2071C17.8946 17.0196 18 16.7652 18 16.5V9.5C18 8.94772 18.4477 8.5 19 8.5C19.5523 8.5 20 8.94772 20 9.5V16.5C20 17.2957 19.6839 18.0587 19.1213 18.6213C18.5587 19.1839 17.7957 19.5 17 19.5H3C2.20435 19.5 1.44129 19.1839 0.87868 18.6213C0.31607 18.0587 0 17.2957 0 16.5V7.5C0 6.70435 0.31607 5.94129 0.87868 5.37868C1.44129 4.81607 2.20435 4.5 3 4.5H5C5.26522 4.5 5.51957 4.39464 5.70711 4.20711C5.89464 4.01957 6 3.76522 6 3.5C6 2.96957 6.21071 2.46086 6.58579 2.08579ZM10 9.5C8.89543 9.5 8 10.3954 8 11.5C8 12.6046 8.89543 13.5 10 13.5C11.1046 13.5 12 12.6046 12 11.5C12 10.3954 11.1046 9.5 10 9.5ZM6 11.5C6 9.29086 7.79086 7.5 10 7.5C12.2091 7.5 14 9.29086 14 11.5C14 13.7091 12.2091 15.5 10 15.5C7.79086 15.5 6 13.7091 6 11.5Z"
                                    fill="#C8D0DD"
                                />
                            </svg>
                            <p class="m-d-0 f-14 f-regular m-t-8" style="color: #C8D0DD">Upload foto / video...</p>
                        </div>
                        <div class="uploaded" v-else>
                            <div style="background-color: black;" id="files-content" @hook:mounted="handleFiles">
                                <div
                                    class="wa-status-thumbnail d-flex-between-center"
                                    style="background: black; justify-content: center;"
                                    v-if="!fileUpload"
                                >
                                    <img
                                        v-if="isImage(posted.type_media)"
                                        :src="`${imageStore}${posted.media_name}`"
                                        style="width: 100%"
                                    />
                                    <img
                                        v-if="isVideo(posted.type_media)"
                                        :src="`${imageStore}thumbnail/${posted.thumb_name}`"
                                        style="width: 100%"
                                    />
                                </div>
                            </div>
                            <div class="d-flex btn-cont">
                                <div class="act-btn" @click="openUpload">
                                    <label class="m-d-0 f-c-blue">{{ updateCaption }}</label>
                                </div>
                                <div class="act-btn" @click="clearFile">
                                    <label class="m-d-0 f-c-red">Hapus</label>
                                </div>
                            </div>
                        </div>
                        <div class="m-t-12">
                            <textarea
                                class="input-caption"
                                v-model="posted.caption"
                                placeholder="Tambahkan caption (opsional)..."
                            ></textarea>
                        </div>
                    </div>
                    <div class="p-t-20">
                        <PostingTime
                            :type-posting="posted.repeat"
                            :set-type-posting="onSelectType"
                            :detail-posting="posted"
                            :set-detail-posting="onUpdateDetail"
                        />
                        <div class="v-error d-none" id="e-posting">
                            Waktu Posting tidak boleh kosong
                        </div>
                    </div>
                    <div class="">
                        <div
                            style="text-align: center; margin-bottom: -8px; margin-top: 36px;"
                            class="f-regular f-c-midgrey f-12"
                        >
                            <label class="m-d-0">
                                <b class="f-c-black">Biaya:</b> 250 M-coin / status yang diposting
                            </label>
                        </div>
                        <SOButton
                            :primary="true"
                            :full="true"
                            :text="'Posting Sekarang'"
                            :disable="!allowSave || isFetching"
                            :id="`create-post`"
                            :loading="isFetching"
                            @action="onSave"
                        />
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOButton from "@/so-components/global/ui/SOButton";

import SoModalOptions from "@/so-components/global/ui/SOModalOptions";
import ErrorMessage from "@/component-items/ErrorMessage";

import PostingTime from "../components/PostingTime.vue";

import { moduleName } from "../store/state";

export default {
    name: "CreateStatus",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SoModalOptions,
        SOButton,
        ErrorMessage,
        PostingTime,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.name === "wa_status.status_aktif") {
                if (from.params.aktif_id) {
                    vm.setAktifId(from.params.aktif_id);
                }
                vm.setReloadPage("aktif");
            }
        });
    },
    data() {
        return {
            reloadPage: "all",
            aktifId: "",
            formReady: false,
            fileLimit: {
                img: 1,
                vid: 16,
            },
            posted: {
                iddevice: null,
                caption: null,
                thumb_name: null,
                media_name: null,
                media: null,
                repeat: 0,
                schedule: "",
                senin: 0,
                selasa: 0,
                rabu: 0,
                kamis: 0,
                jumat: 0,
                sabtu: 0,
                minggu: 0,
                jam: "",
            },
        };
    },
    mounted() {
        this.init();
    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormReady(true);
            }
        },
        fileUpload: function(newFil, oldFil) {
            if (newFil) {
                setTimeout(() => {
                    this.handleFiles();
                }, 200);
            }
        },
        statusFull: function(nStat, oStat) {
            if (this.isEdit) {
                this.setDefaultPosted();
            }
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            listPerangkat: "listPerangkat",
            response: "response",
            deviceid: "deviceid",
            dataDeviceTiny: "dataDeviceTiny",
            isFetching: "isFetching",
            fileUpload: "fileUpload",
            statusFull: "statusFull",
            isVideo: "isVideo",
            isImage: "isImage",
            isText: "isText",
            imageStore: "imageStore",
        }),
        getDateNow() {
            return this.$moment().format("DD/MM/YYYY-HH:mm");
        },
        isNomedia() {
            return !this.posted.media_name && !this.posted.thumb_name;
        },
        isEdit() {
            return this.$route.name === "wa_status.edit_status";
        },
        getTitle() {
            return this.$route.name === "wa_status.edit_status" ? "Ubah Status WA" : "Buat Status WA";
        },
        deviceOptions() {
            let opt = [];
            if (this.listPerangkat.array) {
                this.listPerangkat.array.forEach((data) => {
                    opt.push({
                        value: data.iddevice,
                        title: data.nama,
                        information: `+${data.country_code}${data.number}`,
                    });
                });
            }
            return opt;
        },
        isFileImage() {
            if (this.fileUpload) {
                return this.fileUpload.type.indexOf("image") !== -1;
            } else {
                return false;
            }
        },
        isFileVideo() {
            if (this.fileUpload) {
                return this.fileUpload.type.indexOf("video") !== -1;
            } else {
                return false;
            }
        },
        updateCaption() {
            return this.isFileVideo ? "Ubah video" : "Ubah foto";
        },
        allowSave() {
            let doSave = true;
            let { iddevice, repeat, senin, selasa, rabu, kamis, jumat, sabtu, minggu, jam } = this.posted;
            if (!iddevice) {
                doSave = false;
            }
            if (repeat === 1 && !senin && !selasa && !rabu && !kamis && !jumat && !sabtu && !minggu) {
                doSave = false;
            }

            if (repeat === 1 && !jam) {
                doSave = false;
            }
            return doSave;
        },
        imgLimit() {
            return this.fileLimit.img * 1024 * 1024;
        },
        vidLimit() {
            return this.fileLimit.vid * 1024 * 1024;
        },
    },
    methods: {
        ...mapActions({
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            getListPerangkat: `${moduleName}/getListPerangkat`,
            setFileUpload: `${moduleName}/setFileUpload`,
            updateStatus: `${moduleName}/updateStatus`,
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
            getDetailStatusTn: `${moduleName}/getDetailStatusTn`,
            getListAktivitas: `${moduleName}/getListAktivitas`,
        }),
        setDefaultPosted() {
            this.posted.iddevice = this.statusFull.iddevice;
            this.posted.caption = this.statusFull.caption;
            this.posted.media_name = this.statusFull.media_name;
            this.posted.thumb_name = this.statusFull.thumb_name;
            this.posted.type_media = this.statusFull.type_media;
            this.posted.idschedule = this.statusFull.id;
            this.posted.media = null;
            this.posted.repeat = this.statusFull.repeat;
            this.posted.senin = this.statusFull.senin;
            this.posted.selasa = this.statusFull.selasa;
            this.posted.rabu = this.statusFull.rabu;
            this.posted.kamis = this.statusFull.kamis;
            this.posted.jumat = this.statusFull.jumat;
            this.posted.sabtu = this.statusFull.sabtu;
            this.posted.minggu = this.statusFull.minggu;
            this.posted.jam = this.statusFull.jam;
            this.posted.now = this.statusFull.repeat === 1 ? 0 : 1;
        },
        init() {
            if (this.dataDeviceTiny.iddevice) {
                this.setPosted(this.dataDeviceTiny.iddevice, "iddevice");
            }
            if (this.deviceOptions.length === 0) {
                this.getListPerangkat({ loadDevice: false });
            } else {
                this.setFormReady(true);
            }
        },
        setFormReady(val) {
            this.formReady = val;
        },
        setReloadPage(val) {
            this.reloadPage = val;
        },
        setAktifId(val) {
            this.aktifId = val;
        },
        back() {
            this.$router.go(-1);
        },
        onSelectedOpt(obj, target) {
            this.setPosted(obj.value, target);
        },
        onSelectType(val, target) {
            this.setPosted(val, target);
        },
        onUpdateDetail(val, target) {
            this.setPosted(val, target);
        },
        setPosted(value, target) {
            this.posted[target] = value;
        },
        gotoUpload() {
            this.$router.push({ name: "wa_status.create_status.upload_modal" });
        },
        async openUpload() {
            await this.clearFile();
            await this.gotoUpload();
        },
        clearFile() {
            this.posted.media_name = "";
            this.posted.thumb_name = "";
            this.setFileUpload(null);
        },
        handleInput(e) {
            let val = e.target.value.replace(/[^!@#$%^&*(),.?\t\n\":{}|<>_=\/;\'`~+-\[\]\\a-zA-Z0-9 ]/g, "")

            this.posted.caption = val;
        },
        handleFiles() {
            let el = document.getElementById(`files-content`);

            if (this.isFileVideo) {
                let files = document.createElement("video");
                files.setAttribute("src", URL.createObjectURL(this.fileUpload));
                files.setAttribute("style", "width: 100%");
                files.setAttribute("controls", "controls");
                el.appendChild(files);
            }

            if (this.isFileImage) {
                let files = new Image();
                files.style.width = "100%";
                files.src = URL.createObjectURL(this.fileUpload);
                files.onload = function() {
                    el.appendChild(files);
                };
            }
        },
        errorValidate() {
            let { iddevice, repeat, senin, selasa, rabu, kamis, jumat, sabtu, minggu } = this.posted;
            if (!iddevice) {
                document.getElementById("e-device-wa").classList.toggle("d-none");
            }
            if (repeat === 1 && !senin && !selasa && !rabu && !kamis && !jumat && !sabtu && !minggu) {
                document.getElementById("e-posting").classList.toggle("d-none");
            }
        },
        async onSave() {
            if (!this.allowSave) {
                this.errorValidate();
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }

            let { iddevice, caption, repeat, schedule } = this.posted;

            if (!this.fileUpload && !caption) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }

            if (this.fileUpload && this.fileUpload.size) {
                if (this.isFileImage && this.fileUpload.size > this.imgLimit) {
                    this.$toast.error("Gambar tidak boleh lebih dari 1 MB");
                    return;
                }

                if (this.isFileVideo && this.fileUpload.size > this.vidLimit) {
                    this.$toast.error("Video tidak boleh lebih dari 16 MB");
                    return;
                }
            }

            if (repeat === 0 && schedule && !this.$moment(schedule).isValid()) {
                this.$toast.error("Jadwal tidak valid, Mohon disesuaikan");
                return;
            }

            let post = {
                ...this.posted,
            };

            if (this.isEdit) {
                post.media = this.fileUpload;
                if (post.repeat === 0) {
                    this.$router.push({ name: "wa_status.create_status.confirm_edit", params: { data: post } });
                } else {
                    await this.updateStatus(post)
                        .then((res) => {
                            if (!res.data) {
                                this.$toast.error(res);
                            } else {
                                let { status, code, data, msg } = res.data;
                                if (status && code === 200) {
                                    this.getDetailTinyDevice({ deviceId: data.iddevice });
                                    this.getDetailStatusTn({ iddevice: data.iddevice, idStatus: data.idschedule });
                                    this.getListAktivitas({ iddevice: data.iddevice, idStatus: data.idschedule });
                                    this.setResponse(resulter.successResult(msg, data));
                                    this.$toast.success(msg);
                                    this.back();
                                } else {
                                    this.setResponse(resulter.errorResult(msg, data));
                                    this.$toast.error(msg);
                                }
                            }

                            this.setFetching(false);
                        })
                        .catch((e) => {
                            this.$toast.error(e);
                            this.setFetching(false);
                            this.setResponse(resulter.errorResult(e));
                        });
                }
            } else {
                if (repeat === 0 && !schedule) {
                    post.iddevice = iddevice;
                    post.media = this.fileUpload;
                    post.caption = caption;
                    post.reloadPage = this.reloadPage;
                } else {
                    post.media = this.fileUpload;
                    post.reloadPage = this.reloadPage;
                    if (post.repeat === 1) {
                        post.schedule = "";
                    } else {
                        post.schedule = this.$moment(this.posted.schedule).format("DD/MM/YYYY-HH:mm");
                    }
                }

                if (post.schedule && this.$moment(this.posted.schedule).diff(this.$moment()) <= 0) {
                    this.$toast.error("Tanggal dan Jam harus lebih besar dari sekarang");
                    return;
                }

                this.$router.push({ name: "wa_status.create_status.confirm-posting", params: { data: post } });
            }
        },
    },
};
</script>
<style scoped>
.v-error {
    color: red;
    font-size: 14px;
    margin-top: 4px;
}
.upload-container {
    background-color: #f2f5f7;
    border: 1px solid #c8d0dd;
    padding: 12px;
    padding-bottom: 7px;
    box-sizing: border-box;
    border-radius: 4px;
    overflow: hidden;
}

.upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    background: #ffffff;
    border: 3px dashed #c8d0dd;
    box-sizing: border-box;
    border-radius: 8px;
}
.uploaded {
    background-color: #ffffff;
    box-sizing: border-box;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
}
.btn-cont div:nth-child(1) {
    border-right: 1px solid #dddddd;
}
.act-btn {
    width: 50%;
    padding: 12px 0px;
    text-align: center;
}
.input-caption {
    border: 1px solid #c8d0dd;
    border-radius: 4px;
    height: 116px;
    width: 100%;
    padding: 6px;
}
::placeholder {
    color: #c8d0dd;
}
.wa-status-thumbnail {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}
</style>
